/**src\application\use-cases\user\GetUserUseCase.ts
 * Get User Use Case
 *
 * Retrieves a user by their ID.
 * This use case orchestrates the business logic for getting user data.
 */

import type { IUserRepository } from '@domain/repositories';
import type { User } from '@domain/entities';

export class GetUserUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(userId: string): Promise<User | null> {
    if (!userId || userId.trim().length === 0) {
      throw new Error('User ID is required');
    }

    const user = await this.userRepository.findById(userId);

    if (!user) {
      return null;
    }

    return user;
  }
}
